import { ReactNode } from 'react';
import './styles/main.css';

interface Props {
    value: number | string;
    name: string;
    checked: boolean;
    children: ReactNode;
    onClick: () => void;
}

export default function Radio({ onClick, children, name, value, checked }: Props) {
    return (
        <label onClick={onClick} className="radio-container">
            {children}

            <input type="radio" name={name} id="variant" value={value} checked={checked} />
            <span className="radio-checkmark"></span>
        </label>
    );
}
